import React, { Component } from "react";
import { Trans } from "react-i18next";
import { NavLink, withRouter } from "react-router-dom";
import Loader from "react-loader-spinner";
import { Modal, ModalHeader, ModalBody, TabContent, TabPane } from "reactstrap";
// import { GoogleComponent } from 'react-google-location';
import Autocomplete from "react-google-autocomplete";
import ReCAPTCHA from "react-google-recaptcha";
import axios, { post } from "axios";
import OtpInput from "react-otp-input";
// import { geolocated } from 'react-geolocated';
import FilterResults from "react-filter-search";
import Cookies from "universal-cookie";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  MobileDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
//import DatePicker from 'react-date-picker';
import * as ReactDom from "react-dom";
import ls from "local-storage";
import { options } from "../../config/options";
import "../../config/i18n";
import { withTranslation } from "react-i18next";
import firebaseConfig from "../../firebaseConfig";
import * as firebaseui from "firebaseui";
import firebase from "firebase";
import Webcam from "react-webcam";
import Select from "react-select";
import face from "../../../src/assets/img/face@3x.png";
import { CAPTURE_EVENT, IDENTIFY_USER } from "../../Services/PosthogService";
const API_KEY = "AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ";
const captcha_site_key = "6LeYbcckAAAAABD2QJabSkxLbrEfSrdhEna8oPyU";
//const captcha_site_key = "6Ldn-f0ZAAAAAPiY3xwpLPQQsF1-tWu6v4qCwFQW";

var mine = [];

var setLimit = new Date();
setLimit.setFullYear(setLimit.getFullYear() - 18);

const recaptchaRef = React.createRef();

class Signin extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.firebaseRef = React.createRef();
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.setGender = this.setGender.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onSubmitlocationsearch = this.onSubmitlocationsearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.onChangeSigninemail = this.onChangeSigninemail.bind(this);
    this.onSubmitsignin = this.onSubmitsignin.bind(this);
    this.onChangeSigninpassword = this.onChangeSigninpassword.bind(this);
    this.onChangeForgotemail = this.onChangeForgotemail.bind(this);
    this.onSubmitforgot = this.onSubmitforgot.bind(this);
    this.usePhoneModal = this.usePhoneModal.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onChangeReferal = this.onChangeReferal.bind(this);
    this.onChangeAccess = this.onChangeAccess.bind(this);
    this.onChangeToken = this.onChangeToken.bind(this);
    this.choose = this.choose.bind(this);
    this.chooses = this.chooses.bind(this);
    this.onChangeEye = this.onChangeEye.bind(this);
    this.onChangeSigninEye = this.onChangeSigninEye.bind(this);
    this.state = {
      settings: JSON.parse(localStorage.getItem("settings")),
      valueDate: null,
      maxDate: setLimit,
      // minDate: new Date("01/01/1901"),
      minDate: new Date("1901/01/01"),
      disableIcon: null,
      age: "",
      closeCalendar: true,
      hideCaptureBtn: false,
      backbutton: true,
      capturedimg: true,
      name: "",
      errors: {},
      ios_url: "",
      android_url: "",
      email: "",
      signin_email: "",
      fbid: "",
      fbpic: "",
      googleid: "",
      googlepic: "",
      countryid: "",
      signin_password: "",
      errorMsg: "",
      forgotemail: "",
      password: "",
      dob: "",
      lat: "",
      lon: "",
      gender: "male",
      phone: "",
      phoneDesignPopup: false,
      phoneDisableField: true,
      showNav3: false,
      clickOnce: 0,
      modal: false,
      modal2: false,
      modalOTP: false,
      modalWebCam: false,
      webcamPic: false,
      activeTab: "5",
      interest_arr: [],
      interest_items: [],
      mine: [],
      items: [],
      image: "",
      interests: [],
      country: [],
      image_name: "",
      place: null,
      lat_search: null,
      lon_search: null,
      api_url: localStorage.getItem("api_url"),
      image_url: "",
      peopleforid: "",
      data: [],
      suc_cls: "",
      max_age: "",
      value: "",
      items_interest: [],
      isMJ: false,
      shown: true,
      file: require("../../assets/img/cap1.png"),
      activesignup: "no",
      nointerest: "",
      otp: "",
      numInputs: 4,
      separator: "-",
      isDisabled: false,
      isDisable: false,
      hasErrored: false,
      isInputNum: true,
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
      fileUploaded: "none",
      faceId: "",
      fb_faceId: "",
      faceImage: "",
      loaderDisplay: false,
      permissionAlert: false,
      face_rec: false,
      imageType: "",
      country_text: "Select Country",
      referal: "",
      access_code: "",
      is_special_acc: "0",
      country_err: "",
      dob_err: "",
      token: "",
      stripe_public_key: "",
      modalInfo: false,
      password_type: "password",
      password_icon: "fa fa-eye-slash",
      password_sign_type: "password",
      password_sign_icon: "fa fa-eye-slash",
      modal6: false,
      face_recognition_check_model: false,
      strict_password: "true",
    };
  }

 
  addDefaultSrc(ev) {
    ev.target.src = require("../../assets/img/howzu-logo-default.png");
  }
  // Webcam process
  setRef = (webcam) => {
    this.webcam = webcam;
  };
  captureAgain = () => {
    this.setState({
      webcamPic: false,
      hideCaptureBtn: false,
    });
  };

  backphoto = () => {
    this.setState({
      modalWebCam: false,
      imageType: "",
      faceId: "",
      activeTab: "2",
      //modalInfo: true
    });
  };

  
  saveFaceId = () => {
    this.setState({
      backbutton: false,
    });

    console.log("SAVE FACE ID CALLED");
    if (this.state.fbpic) {
      console.log(1);
      let errors = {};
      var checkImage = new FormData();
      checkImage.append("image", this.state.fbpic);
      checkImage.append("flag", "1");
      checkImage.append("language", this.state.langKey);

      axios({
        method: "post",
        url: this.state.api_url + "checkFaceImage",
        data: checkImage,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        console.log("check faceId");
        console.log(res.data.status);

        if (res.data.status === false) {
          console.log(2);
          errors["captureImg"] = res.data.message;
          this.setState({
            loaderDisplay: false,
            webcamPic: false,
            errors: errors,
            errorMsg: "errorMsg",
            hideCaptureBtn: false,
          });
          setTimeout(() => {
            this.setState({
              errorMsg: "errorMsghide",
            });
          }, 5000);
        } else {
          console.log(3);
          var fbImagecheck = new FormData();
          fbImagecheck.append("faceId", this.state.faceId);
          fbImagecheck.append("faceId2", res.data.faceId);

          axios({
            method: "post",
            url: this.state.api_url + "checkFbFace",
            data: fbImagecheck,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          }).then((res) => {
            if (res.data.status === "false") {
              console.log(4);
              errors["captureImg"] = "";
              this.setState({
                loaderDisplay: false,
                hideCaptureBtn: true,
                file: require("../../assets/img/cap1.png"),
                //fbpic: '',
                activeTab: "2",
                modalWebCam: false,
                fb_faceId: res.data.faceId,
                errors: errors,
                errorMsg: "errorMsg",
              });
              setTimeout(() => {
                errors["captureImg_suc"] = "";
                this.setState({
                  errors: errors,
                  errorMsg: "errorMsghide",
                });
              }, 5000);
            } else {
              console.log(5);
              errors["captureImg"] = "";
              this.setState({
                loaderDisplay: false,
                hideCaptureBtn: true,
                file: this.state.fbpic,
                fbpic: this.state.fbpic,
                activeTab: "2",
                modalWebCam: false,
                fb_faceId: res.data.faceId,
                errors: errors,
                errorMsg: "errorMsg",
              });
              setTimeout(() => {
                errors["captureImg_suc"] = "";
                this.setState({
                  errors: errors,
                  errorMsg: "errorMsghide",
                });
              }, 5000);
            }
          });
        }
      });
    } else {
      console.log(6);
      this.setState({
        hideCaptureBtn: true,
        //modal2:true,
        activeTab: "3",
        modalWebCam: false,
      });
    }
  };
  capture = () => {
    var DetectRTC = require("detectrtc");
    let errors = {};
    this.setState({
      loaderDisplay: true,
    });
    /*DetectRTC.load(() =>{
		if (DetectRTC.hasWebcam) {
			const CAPTURE_OPTIONS = {
				audio: false,
				video: true,
			};
			navigator.mediaDevices.getUserMedia(CAPTURE_OPTIONS,
			() => { */
    const imageSrc = this.webcam.getScreenshot();
    const element = React.createElement("img", {
      src: imageSrc,
    });
    this.setState({
      capturedimg: imageSrc,
    });

    ReactDom.render(element, document.getElementById("capturedPhoto"));
    // Phone number validation for OTP addon
    var checkImage = new FormData();
    checkImage.append("image", imageSrc);
    checkImage.append("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "checkFaceImage",
      data: checkImage,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      console.log("check faceId");
      console.log(res.data.status);

      //res.data.status =true;
      if (res.data.status === false) {
        errors["captureImg"] = res.data.message;
        console.log("working fine...");
        this.setState({
          loaderDisplay: false,
          webcamPic: false,
          //errors: errors,
          //errorMsg:'errorMsg',

          hideCaptureBtn: false,
          // modal6:true,
          face_recognition_check_model: true,
          message: errors,
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 5000);
      } else {
        console.log("HERE COMES" + this.state.fbpic);
        errors["captureImg"] = "";
        //errors["captureImg_suc"] = "Face is matched";
        this.setState({
          loaderDisplay: false,
          webcamPic: true,
          hideCaptureBtn: true,
          verifiedImageData: res.data,
          faceId: res.data.faceId,
          errors: errors,
          errorMsg: "errorMsg",
          faceImage: res.data.userVerificationImage,
          fbpic: "",
        });
        //alert(1)
        setTimeout(() => {
          errors["captureImg_suc"] = "";
          this.setState({
            errors: errors,
            errorMsg: "errorMsghide",
          });
        }, 5000);
      }
    });
  };
  /*	() => {
			this.setState({ 
					loaderDisplay : false,
					permissionAlert: true,
				});
			console.log('Permission Denied');
		},
		);
	}
	else if(window.location.protocol !== 'https:'){
		this.setState({ 
				loaderDisplay : false,
				permissionAlert: true,
			});
	}
});
};*/
  applyReferralFromLink() {
    const cookies = new Cookies();
    const params = new URLSearchParams(
      this.props.location.search || window.location.search
    );
    const referralFromUrl =
      params.get("referral_code") || params.get("referal_code");
    const referralFromCookie = cookies.get("referral_code");
    const referralCode = (referralFromUrl || referralFromCookie || "").trim();

    if (referralCode) {
      this.setState({
        referal: referralCode,
        activesignup: "yes",
      });
      cookies.remove("referral_code", { path: "/" });
    } else if (cookies.get("signuptab") === "yes") {
      this.setState({
        activesignup: "yes",
      });
    }
  }

  componentDidMount() {
    // console.log("settings ",this.state.settings)
    const cookies = new Cookies();
    if (this.state.langKey && this.state.langKey == "fr") {
      this.setState({
        country_text: "Choisissez le pays",
      });
    } else if (this.state.langKey == "ar") {
      this.setState({
        country_text: "حدد الدولة",
      });
    }
    this.applyReferralFromLink();
    // console.log("fbemail",cookies.get('fbemail'));
    const fbEmail = cookies.get("fbemail") || cookies.get("googleemail");
    const fbId = cookies.get("fbid") || cookies.get("googleid");
    const fbName = cookies.get("fbname") || cookies.get("googlename");
    const fbPic = cookies.get("fbpic") || cookies.get("googlepic");
    const googleId = cookies.get("googleid");
    const googlePic = cookies.get("googlepic");

    this.setState({
      email: fbEmail || "",
      fbid: cookies.get("fbid") || "",
      name: fbName || "",
      fbpic: fbPic || "",
      googleid: googleId || "",
      googlepic: googlePic || "",
      phone: cookies.get("signupmobileno") || "",
    });

    if (cookies.get("onboarded") === "true") {
      this.props.history.push("/app");
    }
    axios.get(this.state.api_url + `admindatas`).then((res) => {
      const datas = res.data.result;
      const items = res.data.result.peoplefor;
      const interests = res.data.result.interests;
      const country_raw = res.data.result.country;
      const stripe_public_key = res.data.result.stripe_public_key;
      var country = [];
      country_raw &&
        country_raw.map((i, k) => {
          // console.log('k ~ '+i.id);
          var country_each_index = {};
          country_each_index.value = i.id;
          country_each_index.label = i.name + " - " + i.currencycode;
          country.push(country_each_index);
        });
      if (res.data.result.face_recognition === "enabled") {
        this.setState({ face_rec: true });
      }
      this.setState({
        ios_url: datas["ios_url"],
        android_url: datas["android_url"],
        max_age: datas["max_age"],
        strict_password: datas["strict_password"] || "true",
      });
      this.setState({ items, interests, country });
      this.setState({ captcha_site_key: datas["captcha_site_key"] });
      this.setState({ stripe_public_key: stripe_public_key });
      //localStorage.setItem('stripe_public_key',this.state.stripe_public_key);
    });
  }
  componentDidUpdate() {
    if (this.firebaseRef.current) {
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
        const ui = new firebaseui.auth.AuthUI(firebase.auth());
        const uiConfig = {
          signInOptions: [
            { provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID },
          ],
          signInSuccessUrl: "",
          callbacks: {
            signInSuccessWithAuthResult: async (authResult) => {
              if (authResult["user"]["phoneNumber"]) {
                this.setState({
                  phone: authResult["user"]["phoneNumber"],
                  phoneDisableField: false,
                  phoneDesignPopup: true,
                });
              }
              this.closeModal("modalOTP");
            },
          },
        };
        ui.start("#firebaseui-auth-container-otp", uiConfig);
      }
    }
  }

  componentWillMount() {
    axios.get(this.state.api_url + `admindatas`).then((res) => {
      const data = res.data.result.interests;
      this.setState({
        data,
        settings: res.data.result,
        strict_password: res.data.result.strict_password || "true",
      });
    });
  }
  onChangeSigninpassword(e) {
    this.setState({
      signin_password: e.target.value,
    });
  }
  onChangeSigninemail(e) {
    this.setState({
      signin_email: e.target.value,
    });
    // console.log(e.target.value);
  }
  onChangeReferal(e) {
    this.setState({
      referal: e.target.value,
    });
  }

  onChangeToken(e) {
    //alert(e);
    this.setState({
      token: e.target.value,
    });
  }
  onChangeAccess(e) {
    this.setState({
      access_code: e.target.value,
    });
  }

  onSubmitsignin(e) {
    e.preventDefault();
    let errors = {};
    const cookies = new Cookies();
    /*messaging.onMessage((payload) => // console.log('Message received. ', payload));
		navigator.serviceWorker.addEventListener("message", (message) => // console.log(message));
		*/
    var signin = new FormData();
    signin.set("email", this.state.signin_email.toLowerCase());
    signin.set("password", this.state.signin_password);
    signin.set("fcmtoken", cookies.get("mytoken"));
    signin.set("language", this.state.langKey);

    axios({
      method: "post",
      url: this.state.api_url + "webemaillogin",
      data: signin,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const message = res.data.message;
      // console.log(res.data);
      let formIsValid = true;
      if (res.data.status !== "true") {
        //	// console.log(message);
        formIsValid = false;
        errors["login"] = message;
        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 5000);
      } else {
        var loginstatus = new FormData();
        loginstatus.set("user_id", res.data.peoples.user_id);
        loginstatus.set("status", "1");
        loginstatus.set("language", this.state.langKey);
        axios({
          method: "post",
          url: this.state.api_url + "webonlinestatus",
          data: loginstatus,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        });
        localStorage.setItem(
          "session_token",
          JSON.stringify(res.data.peoples.token)
        );
        localStorage.setItem(
          "session_userid",
          JSON.stringify(res.data.peoples.user_id)
        );
        localStorage.setItem(
          "session_usertype",
          JSON.stringify(res.data.peoples.user_type)
        );
        localStorage.setItem(
          "session_faceverificationstatus",
          res.data.peoples.face_verification_status
        );
        //localStorage.setItem('stripe_public_key',this.state.stripe_public_key);
        sessionStorage.setItem("loggedin", "true");
        //const cookie = new cookie();
        //cookies.set('userimage',res.data.peoples.user_image);

        let d = new Date();
        d.setTime(d.getTime() + 12 * 60 * 60 * 1000);
        cookies.set("onboarded", "true", { path: "/", expires: d });
        localStorage.removeItem("show_signup_tutorial_video");
        // console.log("cookies1",cookies.get('onboarded'));

        if (res.data.peoples.profile_image != "false") {
          this.props.history.push("/app");
        } else {
          this.props.history.push("/app/Profile/ProfilePhotoEdit");
        }
      }
      this.setState({
        errors: errors,
      });
      return formIsValid;
    });
  }

  onChangeForgotemail(e) {
    this.setState({
      forgotemail: e.target.value,
    });
    // console.log(e.target.value);
  }
  onSubmitforgot(e) {
    e.preventDefault();

    let errors = {};
    if (
      this.state.forgotemail.toLowerCase() == "" ||
      this.state.forgotemail.toLowerCase() == undefined
    ) {
      errors["forgot"] = "Please enter valid email";

      this.setState({
        errors: errors,
        errorMsg: "errorMsg",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 6000);
      return;
    } else {
      //var validRegex = new RegExp(/^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/);
      var validRegex = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      );

      console.log("dddddddddddddddddddddddddddd");
      console.log(this.state.forgotemail.toLowerCase());
      console.log(validRegex.test(this.state.forgotemail.toLowerCase()));
      console.log("dddddddddddddddddddddddddddd");
      if (validRegex.test(this.state.forgotemail.toLowerCase()) == false) {
        errors["forgot"] = "Please enter valid email";

        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 6000);
        return;
      } else {
        let errors = {};
        var forgotemail = new FormData();
        forgotemail.set("email", this.state.forgotemail.toLowerCase());
        forgotemail.set("language", this.state.langKey);
        axios({
          method: "post",
          url: this.state.api_url + "webforgot",
          data: forgotemail,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
          const message = res.data.message;

          errors["forgot"] = message;

          this.setState({
            errors: errors,
            errorMsg: "errorMsg",
          });
          setTimeout(() => {
            this.setState({
              errorMsg: "errorMsghide",
            });
          }, 5000);
          if (res.data.status === "true") {
            this.setState({
              forgotemail: "",
            });
          }
          // console.log(message);
        });
      }
    }
  }
  getChckeboxValue(event) {
    // const value = event.target.value;
  }
  onChangeName(e) {
    this.setState({
      name: e.target.value,
      lon: e.target.alt,
    });
  }
  restrict = (event) => {
    const regex = new RegExp("^[a-zA-Z0-9_.-]*$");
    const key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };
  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  isStrictPasswordEnabled() {
    return String(this.state.strict_password) === "true";
  }

  isPasswordValidByPolicy(password) {
    if (!password || password.length < 6) {
      return false;
    }
    if (!this.isStrictPasswordEnabled()) {
      return true;
    }
    const strictRegex = new RegExp(
      /^(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{6,}).*$/
    );
    return strictRegex.test(password);
  }

  getPasswordRuleMessage() {
    if (this.isStrictPasswordEnabled()) {
      return (
        <Trans i18nKey="Password Rule">
          Your password must be least 6 characters including uppercase &
          lowercase,numbers and special characters
        </Trans>
      );
    }
    return (
      <Trans i18nKey="Password minimum rule">
        Your password must be at least 6 characters
      </Trans>
    );
  }

  onChangeEye() {
    if (this.state.password_type == "password") {
      this.setState({
        password_type: "text",
        password_icon: "fa fa-eye",
      });
    } else {
      this.setState({
        password_type: "password",
        password_icon: "fa fa-eye-slash",
      });
    }
  }
  onChangeSigninEye() {
    if (this.state.password_sign_type == "password") {
      this.setState({
        password_sign_type: "text",
        password_sign_icon: "fa fa-eye",
      });
    } else {
      this.setState({
        password_sign_type: "password",
        password_sign_icon: "fa fa-eye-slash",
      });
    }
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value,
      lat: e.target.alt,
    });
  }
  onChangeCountry(e) {
    // console.log(e);
    this.setState({
      countryid: e.value,
    });
  }

  setGender(e) {
    this.setState({
      gender: e.target.value,
    });
  }

  onSubmit(e) {
    e.preventDefault();
    let errors = {};
    let clickOn = 0;
    let acc_err = 0;
    // if(this.state.access_code && this.state.access_code.trim() != '') {
    // 	var access_code = this.state.access_code;
    // 	var chkacc = new FormData();
    // 	chkacc.append('email', this.state.email);
    // 	chkacc.append('language', this.state.langKey);
    // 	chkacc.append('countryid', this.state.countryid);
    // 	chkacc.append('name', this.state.name);
    // 	//console.log(signup);return false;
    // 	axios({
    // 		method: 'post',
    // 		url: this.state.api_url+'checkaccesscode',
    // 		data: chkacc,
    // 		config: { headers: {'Content-Type': 'multipart/form-data' }}
    // 	}).then(res => {
    // 		if(res == '1') {
    // 			acc_err = 1;
    // 		}
    // 	})
    // }

    //  const recaptchaValue = recaptchaRef.current.getValue();
    const recaptchaValue = "1";
    console.log("*********************");
    console.log(this.state.email);
    console.log("*********************");
    //	recaptchaValue="ss";
    // if(this.state.password != '' && recaptchaValue !== '' && this.state.countryid !== '' && this.state.email !== null && this.state.dob !== null && this.state.age !== null && this.state.phone !== null && this.state.email !== "" && this.state.dob !== "" && this.state.age !== "" && this.state.token !== "" && clickOn === 0) {
    if (recaptchaValue !== "") {
      // var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      var pattern = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      );

      this.setState({
        country_err: "",
        dob_err: "",
        captcha_err: "",
      });

      //var validRegex = new RegExp(/^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/);
      var validRegex = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      );

      // if (!pattern.test(this.state.email)) {
      console.log("555555555555555555555555555555555555555");
      //console.log(this.state.email.toLowerCase());
      console.log("555555555555555555555555555555555555555");
      if (this.state.countryid === "") {
        this.setState({
          country_err: "Kindly choose country list from dropdown",
          errorMsg: "WebcameAlert",
        });
        return;
      } else if (this.state.name == "" || this.state.name == undefined) {
        console.log("##44444444444444444444444444######");
        errors["name"] = "name";
        errors["signup"] = "Enter your name(It should be atleast 3 characters)";
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
        return;
      } else if (
        this.state.email == "" ||
        this.state.email == undefined ||
        validRegex.test(this.state.email.toLowerCase()) == false
      ) {
        errors["email"] = "email";
        console.log("======================email test======");
        console.log(this.state.langKey);
        console.log("======================email test======");
        if (this.state.langKey == "ar") {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email addressar">
              Enter a valid email address
            </Trans>
          );
        } else {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email address">
              Enter a valid email address
            </Trans>
          );
        }
        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 6000);
        clickOn = 0;
        return;
      }

      // var regix = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})");
      console.log("here");
      console.log("passsssssssss");
      console.log(this.isPasswordValidByPolicy(this.state.password));
      console.log("passsssssssss");
      // var regix = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])");
      if (!this.isPasswordValidByPolicy(this.state.password)) {
        errors["password"] = "password";
        errors["signup"] = this.getPasswordRuleMessage();
        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 6000);
        clickOn = 0;
        return;
      } else if (this.state.dob === "") {
        this.setState({
          dob_err: "Kindly choose the calender information",
        });
        this.setState({
          f_err: "",
        });
        this.setState({
          country_err: "",
        });
        return;
      }

      this.setState({
        isDisable: true,
      });
      //alert(this.state.countryid)
      var signup = new FormData();
      signup.append("email", this.state.email.toLowerCase());
      signup.append("language", this.state.langKey);
      signup.append("countryid", this.state.countryid);
      signup.append("name", this.state.name);
      signup.append("access_code", this.state.access_code);
      signup.append("referral_code", this.state.referal);
      signup.set("token", this.state.token);
      signup.set("countryid", this.state.countryid);
      signup.set("gender", this.state.gender);
      clickOn = 1;
      //console.log(signup);return false;
      axios({
        method: "post",
        url: this.state.api_url + "webcheckemail",
        data: signup,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        const message = res.data.message;

        if (res.data.status === "true") {
          if (res.data.email_verified === "disabled") {
            this.setState({
              activeTab: "1",
            });
          } else {
            this.setState({
              activeTab: "6",
            });
          }
          if (this.state.access_code.trim() != "") {
            this.setState({
              is_special_acc: "1",
            });
          }
          // Phone number validation for OTP addon
          // var checkPhoneNo = new FormData();
          // checkPhoneNo.append('phone', this.state.phone);
          // axios({
          // 	method: 'post',
          // 	url: this.state.api_url+'webcheckphone',
          // 	data: checkPhoneNo,
          // 	config: { headers: {'Content-Type': 'multipart/form-data' }}
          // }).then(res => {
          // 	const message = res.data.message;
          // 	if(res.data.status === "false") {
          //      	errors["signup"] = message;
          // 		this.setState({
          // 			errors: errors,
          // 			errorMsg:'errorMsg',
          // 			phoneDisableField: true,
          //             phoneDesignPopup: false,
          // 		});
          // 		setTimeout(() => {
          // 			this.setState({
          // 				errorMsg: 'errorMsghide'
          // 			});
          // 		}, 4000);
          // 	} else {
          this.setState({
            //modalWebCam: true
            modal2: true,
          });
          // 	}
          // 	this.setState({
          // 		errors: errors
          // 	});
          // 	clickOn = 0;
          // })

          /*this.setState({
						modal2: true
					});*/
        } else {
          this.setState({
            isDisable: false,
          });

          signup.set("email", "");
          errors["message_info"] = res.data.message_info;
          errors["signup"] = message;
          this.setState({
            errors: errors,
            errorMsg: "errorMsg",
          });
          setTimeout(() => {
            this.setState({
              errorMsg: "errorMsghide",
            });
          }, 6000);
        }
        this.setState({
          errors: errors,
        });
        clickOn = 0;
      });
    } else {
      console.log("########");

      // var pattern = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );

      // if (!pattern.test(this.state.email)) {
      console.log("555555555555555555555555555555555555555");
      console.log(pattern.test(this.state.email));
      console.log("555555555555555555555555555555555555555");
      if (this.state.countryid === "") {
        this.setState({
          country_err: "Kindly choose country list from dropdown",
          errorMsg: "WebcameAlert",
        });
      } else if (this.state.name == "" || this.state.name == undefined) {
        console.log("##44444444444444444444444444######");
        errors["name"] = "name";
        errors["signup"] = "Enter your name(It should be atleast 3 characters)";
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (this.state.email == "" || this.state.email == undefined) {
        console.log("##44444444444444444444444444######");

        errors["email"] = "email";
        console.log("======================email test======");
        console.log(this.state.langKey);
        console.log("======================email test======");
        if (this.state.langKey == "ar") {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email addressar">
              Enter a valid email address
            </Trans>
          );
        } else {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email address">
              Enter a valid email address
            </Trans>
          );
        }
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (
        this.state.email.toLowerCase() == "" ||
        this.state.email.toLowerCase() == undefined
      ) {
        console.log("##44444444444444444444444444######");

        errors["email"] = "email";
        if (this.state.langKey == "ar") {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email addressar">
              "Enter a valid email address"
            </Trans>
          );
        } else {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email address">
              "Enter a valid email address"
            </Trans>
          );
        }
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (pattern.test(this.state.email.toLowerCase()) == false) {
        errors["email"] = "email";
        if (this.state.langKey == "ar") {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email addressar">
              "Please enter the valid email address"
            </Trans>
          );
        } else {
          errors["signup"] = (
            <Trans i18nKey="Enter a valid email address">
              "Please enter the valid email address"
            </Trans>
          );
        }
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (
        this.state.password == "" ||
        this.state.password == undefined
      ) {
        console.log("##44444444444444444444444444######");
        errors["password"] = "password";
        errors["signup"] = this.getPasswordRuleMessage();
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (!this.isPasswordValidByPolicy(this.state.password)) {
        errors["password"] = "password";
        errors["signup"] = this.getPasswordRuleMessage();
        this.setState({
          errors: errors,
          errorMsg: "WebcameAlert",
        });

        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (this.state.dob === "") {
        this.setState({
          dob_err: "Kindly choose the calender information",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else if (recaptchaValue == "") {
        this.setState({
          captcha_err: "You must verify the captcha",
        });
        this.setState({
          dob_err: "",
        });
        this.setState({
          country_err: "",
        });
      } else {
        errors["signup"] = (
          <Trans i18nKey="Please fill the details">
            Fill in your registration details correctly
          </Trans>
        );
        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        this.setState({
          dob_err: "",
        });
        this.setState({
          captcha_err: "",
        });
        this.setState({
          country_err: "",
        });
      }

      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 6000);

      clickOn = 0;
    }
  }
  onSubmitlocationsearch(e) {
    e.preventDefault();

    let errors = {};
    let clickOnce = this.state.clickOnce;

    console.log(
      "location",
      this.state.lon_search + " " + this.state.lat_search
    );
    // -------------------------------------------

    if (
      this.state.lat_search === "" ||
      this.state.lat_search === null ||
      this.state.lon_search === "" ||
      this.state.place === "" ||
      this.state.place === null
    ) {
      errors["locationsearch"] = "Select location properly or change location";
      this.setState({
        errors: errors,
        errorMsg: "errorMsg",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 2000);
    } else if (
      typeof this.state.lat_search === "undefined" ||
      typeof this.state.lat_search === "undefined"
    ) {
      errors["locationsearch"] = "please select the location from dropdown";
      this.setState({
        errors: errors,
        errorMsg: "errorMsg",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 2000);
    }

    // -----------------------------------------------

    // if(typeof(this.state.lat_search) === 'undefined' || typeof(this.state.lon_search) === 'undefined' || this.state.lat_search === 'undefined' || this.state.lat_search === "" || this.state.lat_search === null || this.state.lon_search === "" || this.state.lon_search === 'undefined' || this.state.place=== "" || this.state.place=== null || this.state.place === 'undefined'){
    // 		errors["locationsearch"] = "Select location properly or change location";
    // 		this.setState({
    // 			errors: errors,
    // 			errorMsg:'errorMsg'
    // 			});
    // 			setTimeout(() => {
    // 					this.setState({
    // 							errorMsg: 'errorMsghide'
    // 					});
    // 				}, 2000);
    // }
    else {
      if (clickOnce === 0) {
        this.setState({
          clickOnce: 1,
        });
        var signup = new FormData();
        signup.set("check", this.state.interest_arr);
        signup.set("name", this.state.name);
        signup.set("email", this.state.email);
        signup.set("password", this.state.password);
        signup.set("phone", this.state.phone);
        signup.set("dob", this.state.dob);
        signup.set("age", this.state.age);

        if (
          this.state.gender === "" ||
          this.state.gender === null ||
          this.state.gender === "undefined"
        ) {
          signup.set("gender", "female");
        } else {
          signup.set("gender", this.state.gender);
        }

        if (this.state.fbid) {
          signup.set("fbid", this.state.fbid);
        }
        if (this.state.googleid) {
          signup.set("googleid", this.state.googleid);
        }

        if (this.state.googlepic) {
          signup.set("googlepic", this.state.googlepic);
        }

        if (this.state.fbpic) {
          console.log("fbpic=" + this.state.fbpic);
          // signup.set('image_name', '');
          // signup.set('image_url', '');
          signup.set("fbpic", this.state.fbpic);
          signup.set("image_name", this.state.image_name);
          signup.set("image_url", this.state.image_url);
        } else {
          signup.set("fbpic", "");
          signup.set("image_name", this.state.image_name);
          signup.set("image_url", this.state.image_url);
          console.log("signup set" + this.state.image_name);
        }
        signup.set("peopleforid", this.state.peopleforid);
        signup.set("lat", this.state.lat_search);
        signup.set("lon", this.state.lon_search);
        signup.set("location", this.state.place);
        signup.set("language", this.state.langKey);
        signup.set("faceId", this.state.faceId);
        signup.set("countryid", this.state.countryid);
        signup.set("imagetype", this.state.imageType);
        signup.set("selected_facreg", this.state.face_rec);
        signup.set("referral_code", this.state.referal);
        signup.set("is_special_acc", this.state.is_special_acc);
        signup.set("access_code", this.state.access_code);
        signup.set("token", this.state.token);
        // alert(this.state.referal);

        axios({
          method: "post",
          url: this.state.api_url + "signupweb",
          data: signup,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then(async (res) => {
          if (res.data.status !== "true") {
            errors["locationsearch"] = res.data.message;
            this.setState({
              errors: errors,
              errorMsg: "errorMsg",
            });
            setTimeout(() => {
              this.setState({
                errorMsg: "errorMsghide",
              });
            }, 2000);
            this.setState({
              clickOnce: 0,
            });
          } else {
            let signup_activity = this.state.api_url + "signupactivity";
            const response = await axios.post(signup_activity, {
              user_id: res.data.user_id,
            });

            console.log(response);

            IDENTIFY_USER(res.data.peoples.user_id, {
              email: this.state.email,
            });
            let signup_properties = {
              properties: {
                user_email: this.state.email,
                user_age: String(this.state.age),
                user_name: this.state.name,
                user_id: res.data.user_id,
                user_location: this.state.place,
              },
            };
            CAPTURE_EVENT("signup", signup_properties);
            this.setState({
              isDisable: false,
            });

            signup.set("check", "");
            signup.set("name", "");
            signup.set("email", "");
            signup.set("password", "");
            signup.set("dob", "");
            signup.set("gender", "");
            signup.set("image_name", "");
            signup.set("image_url", "");
            signup.set("peopleforid", "");
            signup.set("lat", "");
            signup.set("lon", "");
            signup.set("location", "");
            signup.set("countryid", "");
            signup.set("token", "");
            var signin = new FormData();
            signin.set("email", this.state.email);
            signin.set("password", this.state.password);
            signin.set("language", this.state.langKey);

            if (res.data.peoples.referred_signup_msg) {
              localStorage.setItem(
                "referred_signup_msg",
                res.data.peoples.referred_signup_msg
              );
              localStorage.setItem("referred_signup_msg_showed", "0");
            }
            // signin.set('referral_code', this.state.referal);

            // let free_premium=res.data.peoples.free_premium_enabled;
            console.log(
              "free_premium_enabled=" + res.data.peoples.free_premium_enabled
            );
            localStorage.setItem(
              "free_premium_enabled",
              res.data.peoples.free_premium_enabled
            );
            localStorage.setItem(
              "free_premium_days",
              res.data.peoples.free_premium_days
            );

            axios({
              method: "post",
              url: this.state.api_url + "webemaillogin",
              data: signin,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            }).then((res) => {
              let formIsValid = true;
              if (res.data.status !== "true") {
                errors["locationsearch"] = res.data.message;
                this.setState({
                  errors: errors,
                  errorMsg: "errorMsg",
                });
                setTimeout(() => {
                  this.setState({
                    errorMsg: "errorMsghide",
                  });
                }, 2000);
                this.setState({
                  clickOnce: 0,
                });
              } else {
                var loginstatus = new FormData();
                loginstatus.set("user_id", res.data.peoples.user_id);
                loginstatus.set("status", "1");
                loginstatus.set("language", this.state.langKey);
                axios({
                  method: "post",
                  url: this.state.api_url + "webonlinestatus",
                  data: loginstatus,
                  config: {
                    headers: { "Content-Type": "multipart/form-data" },
                  },
                });
                let d = new Date();
                const cookies = new Cookies();
                d.setTime(d.getTime() + 12 * 60 * 60 * 1000);
                cookies.set("onboarded", "true", { path: "/", expires: d });
                localStorage.setItem("show_signup_tutorial_video", "true");

                localStorage.setItem(
                  "session_token",
                  JSON.stringify(res.data.peoples.token)
                );
                localStorage.setItem(
                  "session_userid",
                  JSON.stringify(res.data.peoples.user_id)
                );
                localStorage.setItem(
                  "session_usertype",
                  JSON.stringify(res.data.peoples.user_type)
                );

                localStorage.setItem(
                  "session_faceverificationstatus",
                  res.data.peoples.face_verification_status
                );
                sessionStorage.setItem("loggedin", "true");
                cookies.set("fbemail", "");
                cookies.set("fbid", "");
                cookies.set("fbname", "");
                cookies.set("fbpic", "");
                cookies.set("googleemail", "");
                cookies.set("googleid", "");
                cookies.set("googlename", "");
                cookies.set("googlepic", "");
                this.props.history.push("/app/PeopleNear");
              }

              return formIsValid;
            });
          }
        });
      }
    }
    this.setState({
      errors: errors,
    });
  }
  handleItemClick(index) {
    this.setState({
      activeItem: index,
    });
  }

  closeModal(tabId) {
    console.log(tabId);
    this.setState({
      [tabId]: false,
    });
  }
  showModal(modal) {
    this.setState({
      [modal]: true,
    });
  }
  usePhoneModal() {
    console.log("checking process....");
    this.setState({
      phoneDisableField: false,
      phoneDesignPopup: true,
    });
  }
  handlehereClick(index, e) {
    this.setState({
      activehere: index,
      peopleforid: e.target.alt,
    });
    localStorage.setItem("peopleforid", JSON.stringify(e.target.alt));
  }
  validate(e) {
    e.preventDefault();

    // if(this.state.capturedimg !== true)
    // {
    // 	const element = React.createElement(
    // 		'img',
    // 		{
    // 		   src:this.state.capturedimg
    // 		}
    // 	  );

    // 	  ReactDom.render(element, document.getElementById("capturedPhoto"));
    // }

    this.setState({
      webcamPic: false,
      hideCaptureBtn: false,
    });

    let errors = {};
    if (this.state.peopleforid === "" || this.state.peopleforid === null) {
      errors["here_to"] = "Please select any one";
      this.setState({
        errors: errors,
        errorMsg: "errorMsg",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 2000);
    } else {
      if (this.state.fbpic) {
        this.setState({
          //activeTab: '8',
          //file: this.state.fbpic,
          modalInfo: true,
          //modalWebCam: true,
          //imageType:"selfie"
        });
      } else {
        this.setState({
          modalInfo: true,
          /*modalWebCam: true,
					imageType:"selfie"*/
          //activeTab: '8'
        });
      }
    }
  }
  choose(e) {
    e.preventDefault();
    let errors = {};
    if (this.state.peopleforid === "" || this.state.peopleforid === null) {
      errors["here_to"] = "Please select any one";
      this.setState({
        errors: errors,
        errorMsg: "errorMsg",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 2000);
    } else {
      this.setState({
        activeTab: "2",
      });
    }
  }

  chooses(e) {
    this.setState({
      //activeTab: '11'
      modalWebCam: true,
      imageType: "selfie",
      modalInfo: false,
    });
  }
  onFormSubmit(e) {
    //e.preventDefault()
    this.fileUpload(this.state.image);
  }
  onChange(e) {
    console.log("onChange called");
    this.setState({
      file: URL.createObjectURL(e.target.files[0]),
    });
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    console.log(files[0]);
    this.createImage(files[0]);
  }
  /*createImage(file) {
		  console.log("createImage called");
	  let reader = new FileReader();  
	  reader.onload = (e) => {
		this.setState({
		  image: e.target.result
		})
		 if(this.state.imageType=="" || this.state.imageType!="selfie"){
			  this.setState({
		  imageType:"gallery"
		})
		}
		this.onFormSubmit();
	  };
	  reader.readAsDataURL(file);
	  
	}*/

  async createImage(file) {
    console.log("createImage called");
    let reader = new FileReader();
    var file_err = 0;
    var err = 0;
    reader.onload = (e) => {
      this.setState({
        image: e.target.result,
      });

      var image = new Image();
      image.src = e.target.result;
      const scope = this;
      image.onload = async function () {
        var height = this.height; //alert(height);
        var width = this.width; //alert(width);

        if (
          (height > 1500 || height > 1500) &&
          (width > 1500 || width > 1500)
        ) {
          file_err++;
          //alert('Height and Width must not exceed 1920*400.');
          err++;
          await scope.setState({
            //modal6:true,
            img_validation: 1,
          });
        } else {
          file_err = 0;
          await scope.setState({
            img_validation: 0,
            //modal6:false,
            //images: e.target.result
          });
        }
      };
    };

    //alert(this.state.img_validation);
    await reader.readAsDataURL(file);
    if (this.state.imageType == "" || this.state.imageType != "selfie") {
      this.setState({
        imageType: "gallery",
      });
    }
    setTimeout(() => {
      this.onFormSubmit();
    }, 1000);
  }
  fileUpload(image) {
    if (this.state.img_validation == 0) {
      let errors = {};
      this.setState({
        loaderDisplay: true,
      });
      console.log("imageType" + this.state.imageType);
      if (this.state.image === null || this.state.image === "") {
        this.setState({
          fileUploaded: "none",
        });
        errors["uploadimage"] = "Please atleast select one Image";
        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 2000);
      } else {
        this.setState({
          fileUploaded: "upload",
          loaderDisplay: true,
        });

        const url = this.state.api_url + "uploadimageweb";
        const formData = {
          file: this.state.image,
          imagetype: this.state.imageType,
          faceId: this.state.faceId,
          type: "beforeSignup",
          language: this.state.langKey,
        };

        console.log("sending data:" + JSON.stringify(formData));

        return post(url, formData).then((res) => {
          console.log("verify status ");
          console.log(res.data.status);
          console.log(res.data);
          console.log("res.data end");
          if (res.data.status === "true") {
            const image_url = res.data.imageurl;
            const image_name = res.data.image_name;
            errors["uploadimage"] = "";
            errors["uploadimage_suc"] = "Image uploaded sucessfuly";
            this.setState({
              image_name: image_name,
              image_url: image_url,
              loaderDisplay: false,
              errors: errors,
              hideCaptureBtn: true,
            });
            this.setState({
              errors: errors,
              errorMsg: "errorMsg",
            });
            setTimeout(() => {
              this.setState({
                errorMsg: "errorMsghide",
              });
            }, 5000);
            localStorage.setItem(
              "image_name",
              JSON.stringify(this.state.image_name)
            );
            localStorage.setItem(
              "image_url",
              JSON.stringify(this.state.image_url)
            );
            // this.setState({
            // 	activeTab: '3'
            // });
            console.log("image_name" + this.state.image_name);
            console.log("image_url" + this.state.image_url);
            this.setState({
              activeTab: "4",
            });

            document.getElementById("next").style.display = "block";
          } else {
            errors["uploadimage"] = res.data.message;
            console.log("facial id");
            console.log(this.state.faceId);
            console.log("image type");
            console.log(this.state.imageType);
            if (this.state.imageType && this.state.imageType == "selfie") {
              this.setState({
                face_recognition_check_model: true,
              });
            } else {
              this.setState({
                modal6: true,
              });
            }
            this.setState({
              file: require("../../assets/img/cap1.png"),
              //errors: errors,
              //errorMsg:'errorMsg',
              fileUploaded: "none",
              hideCaptureBtn: false,
              loaderDisplay: false,
              //modal6: true,
              //face_recognition_check_model:true,
              message: errors,
            });
            setTimeout(() => {
              this.setState({
                errorMsg: "errorMsghide",
              });
            }, 5000);
          }
        });
      }
    } else {
      this.setState({
        //errors: errors,
        file: require("../../assets/img/cap1.png"),
        fileUploaded: "none",
        hideCaptureBtn: false,
        loaderDisplay: false,
        modal6: true,
      });
    }
  }
  onToggle(index, e) {
    let newItems = this.state.interests.slice();
    newItems[index].checked = !newItems[index].checked;

    if (e.target.value) {
      var cur_val = e.target.value;
      // console.log({cur_val});
      //// console.log(mine.includes(cur_val));
      index = mine.indexOf(cur_val);
      if (index > -1) {
        mine.splice(index, 1);
        this.setState({ checked: !this.state.checked });
      } else {
        mine.push(cur_val);
      }
    }
  }
  onSubmitinterest = (e) => {
    e.preventDefault();
    // let errors = {};
    // console.log("change_int",mine);

    if (mine.length === 0) {
      this.setState({
        nointerest: (
          <Trans i18nKey="Choose your interests">Choose your interests</Trans>
        ),
      });
    } else {
      this.setState({
        interest_arr: mine,
      });

      this.setState({
        activeTab: "5",
      });
    }
  };
  toggle(tab) {
    console.log(this.state.activeTab);
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  handleChange = (event) => {
    const { value } = event.target;
    this.setState({ value });
    this.setState({ interest_items: mine });

    // console.log(this.state.interest_items);
  };

  handleOtpChange = (otp) => {
    this.setState({ otp });
  };

  clearOtp = () => {
    this.setState({ otp: "" });
  };

  handleResendOtp = (e) => {
    e.preventDefault();

    let errors = {};
    var signup = new FormData();
    signup.append("email", this.state.email);
    signup.append("language", this.state.langKey);
    signup.append("name", this.state.name);
    //signup.set('token', this.state.token);
    axios({
      method: "post",
      url: this.state.api_url + "webcheckemail",
      data: signup,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      errors["otpverify"] = res.data.message;
      this.setState({
        errors: errors,
        errorMsg: "errorMsg",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "errorMsghide",
        });
      }, 2000);

      signup.set("email", "");
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    let errors = {};
    var emailVerify = new FormData();
    emailVerify.set("otp", this.state.otp);
    emailVerify.set("email", this.state.email);
    emailVerify.set("language", this.state.langKey);

    axios({
      method: "post",
      url: this.state.api_url + "verifyotp",
      data: emailVerify,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status !== "true") {
        errors["otpverify"] = res.data.message;
        this.setState({
          errors: errors,
          errorMsg: "errorMsg",
        });
        setTimeout(() => {
          this.setState({
            errorMsg: "errorMsghide",
          });
        }, 2000);
      } else {
        emailVerify.set("otp", "");
        emailVerify.set("email", "");

        this.setState({
          activeTab: "1",
        });
      }
    });
  };

  handleOpenPicker = (date) => {
    var setLimit = new Date();
    setLimit.setFullYear(setLimit.getFullYear() - 18);
    this.setState({
      valueDate: setLimit,
      maxDate: setLimit,
    });

    var month = "" + (setLimit.getMonth() + 1),
      day = "" + setLimit.getDate(),
      year = setLimit.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    var newDate = [year, month, day].join("-");

    var ageDiff = Date.now() - setLimit.getTime();
    var ageDate = new Date(ageDiff);
    var yearsDiff = Math.abs(ageDate.getUTCFullYear() - 1970);

    this.setState({
      age: yearsDiff,
      dob: newDate,
    });
  };

  handleDOBChange = (date) => {
    //alert(date);
    this.setState({
      valueDate: date,
    });

    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    var newDate = [year, month, day].join("-");

    var ageDiff = Date.now() - date.getTime();
    var ageDate = new Date(ageDiff);
    var yearsDiff = Math.abs(ageDate.getUTCFullYear() - 1970);

    this.setState({
      age: yearsDiff,
      dob: newDate,
    });

    //alert(newDate+ " - AGE: "+yearsDiff);
  };

  render() {
    const { data, value } = this.state;
    const { t } = this.props;
    const videoConstraints = {
      width: 400,
      height: 720,
      facingMode: "user",
    };
    const {
      otp,
      numInputs,
      separator,
      isDisabled,
      isDisable,
      hasErrored,
      isInputNum,
      country,
      face_rec,
    } = this.state;
    var style = {
      zIndex: 10,
      backgroundColor: "transparent",
      height: 400,
      width: 400,
      position: "absolute",
      justifyContent: "center",
      alignItems: "center",
      display: this.state.loaderDisplay === true ? "block" : "none",
      overflowY: "hidden",
    };
    var style1 = {
      zIndex: 10,
      top: "150px",
      left: "48%",
      backgroundColor: "transparent",
      height: "100%",
      width: "100%",
      position: "absolute",
      justifyContent: "center",
      alignItems: "center",
      display: this.state.loaderDisplay === true ? "block" : "none",
    };
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className="signInPage">
          <div className="border-bottom welcomeHeader white-bg">
            <div className="container">
              <div className="d-flex  apt5 apb5">
                <div className="align-self-center ">
                  <div className="iconHolder align-self-center mr-1">
                    <div className="backGlow">
                      <NavLink exact to="/">
                        <div className="backIco"></div>
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div className="align-self-center ml-auto mr-auto">
                  <img
                    src={require("../../assets/img/logo-c-64.png")}
                    className="sideLogo commonLogoC mr-5"
                    alt="logo"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="signInForms mb-auto align-self-center">
            <ul class="nav nav-tabs justify-content-center">
              <li class="nav-item flex-fill text-center">
                <a
                  id="signin-link"
                  className={
                    "nav-link " +
                    (this.state.activesignup === "no" ? "active" : "")
                  }
                  data-toggle="tab"
                  href="#signin"
                >
                  <Trans i18nKey="Signin">
                    <span className="floating-label">Signin</span>{" "}
                  </Trans>
                </a>
              </li>
              <li class="nav-item flex-fill text-center">
                <a
                  id="signup-link"
                  className={
                    "nav-link " +
                    (this.state.activesignup === "yes" ? "active" : "")
                  }
                  data-toggle="tab"
                  href="#signup"
                >
                  <Trans i18nKey="Signup">
                    <span className="floating-label">Signup</span>{" "}
                  </Trans>
                </a>
              </li>
            </ul>

            <div className={this.state.suc_cls}>
              {this.state.errors.forgot_suc}
            </div>
            <div class="tab-content edit-profile-page">
              <div
                id="signin"
                className={
                  "container tab-pane " +
                  (this.state.activesignup === "no" ? "active" : "fade")
                }
              >
                <form className="apb30 apt30" onSubmit={this.onSubmitsignin}>
                  <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText"
                        type="email"
                        id="signin_email"
                        value={this.state.signin_email}
                        onChange={this.onChangeSigninemail}
                        pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                        placeholder=" "
                        required
                        onInvalid={(F) =>
                          F.target.setCustomValidity(
                            t("Enter a valid email address")
                          )
                        }
                        onInput={(F) => F.target.setCustomValidity("")}
                      />
                      <span className="floating-label">
                        <Trans i18nKey="Email">Email</Trans>
                      </span>
                    </div>
                  </div>

                  <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText"
                        id="signin_password"
                        minLength={6}
                        value={this.state.signin_password}
                        onChange={this.onChangeSigninpassword}
                        type={this.state.password_sign_type}
                        placeholder=" "
                        required
                        onInvalid={(F) =>
                          F.target.setCustomValidity(t("Enter your password"))
                        }
                        onInput={(F) => F.target.setCustomValidity("")}
                      />
                      <i
                        class={this.state.password_sign_icon}
                        onClick={this.onChangeSigninEye}
                        aria-hidden="true"
                      ></i>
                      <span className="floating-label">
                        <Trans i18nKey="Password">Password</Trans>
                      </span>
                    </div>
                  </div>

                  <div className={this.state.errorMsg}>
                    <Trans i18nKey={this.state.errors.login}>
                      {this.state.errors.login}
                    </Trans>
                  </div>
                  <div className="premium amt35 amb15">
                    <button
                      className="btn btn-bg d-flex justify-content-center width100"
                      type="submit"
                    >
                      {" "}
                      <Trans i18nKey="Signin">Signin</Trans>{" "}
                    </button>
                  </div>

                  <div
                    className="float-right secondary_color forgot-password pointCurs"
                    onClick={this.showModal.bind(this, "modal1")}
                  >
                    {" "}
                    <Trans i18nKey="ForgotPassword?">
                      Forgot Password?
                    </Trans>{" "}
                  </div>
                </form>

                {/* Forgot Password Popup */}
                <Modal
                  isOpen={this.state.modal1}
                  toggle={this.closeModal.bind(this, "modal1")}
                  className="premiumPopup modal-dialog-centered vertically-center apd5"
                >
                  <ModalHeader toggle={this.closeModal.bind(this, "modal1")}>
                    <h4 class="modal-title">
                      <Trans i18nKey="ForgotPassword">Forgot Password</Trans>
                    </h4>
                  </ModalHeader>
                  <ModalBody>
                    <div className="modal-body edit-profile-page">
                      <form className=" " onSubmit={this.onSubmitforgot}>
                        <div className="user-input-wrp amb25">
                          <br />
                          {/* onInvalid={F => F.target.setCustomValidity(t('Enter a valid email address'))} onInput={F => F.target.setCustomValidity('')} */}
                          <input
                            className="inputText"
                            name="forgotemail"
                            type="text"
                            id="forgotemail"
                            value={this.state.forgotemail}
                            onChange={this.onChangeForgotemail}
                            placeholder=" "
                          />
                          <span className="floating-label">
                            <Trans i18nKey="Email">Email</Trans>
                          </span>
                        </div>
                        <div className={this.state.errorMsg}>
                          <Trans i18nKey={this.state.errors.forgot}>
                            {this.state.errors.forgot}
                          </Trans>{" "}
                        </div>
                        <button
                          className="btn btn-bg d-flex justify-content-center width100 amg0"
                          type="submit"
                        >
                          {" "}
                          <Trans i18nKey="Reset">Reset</Trans>{" "}
                        </button>
                      </form>
                    </div>
                  </ModalBody>
                </Modal>
              </div>

              <div
                id="signup"
                className={
                  "container tab-pane " +
                  (this.state.activesignup === "yes" ? "active" : "fade")
                }
                onSubmit={this.onSubmit}
              >
                {/* register form */}
                <form className="apb30 apt30">
                  {/* <NavLink to="/Signupfirebase">
									<div className="edit-profile-page">
										<div className="user-input-wrp amb25">
									        <div><Trans i18nKey="Phone">Phone</Trans></div>
									        <div className="d-flex customLine">
								            <div className="align-self-center mr-2 text-dark sign-phone">{this.state.phone}</div>
								            <div className="rightArrow align-self-center"></div>
									        </div>
									    </div>
									</div>
								</NavLink> */}
                  {/*<div className="form-group">
									<label className="amt15"><Trans i18nKey="Country">Country</Trans></label>    
									<br />
									<select className="select-language" onChange={this.onChangeCountry} required>
                                    <option key="-" value=""> -Select- </option>
                                      {country.map(con => (
                                        <option key={con.id} value={con.id}>
                                          {con.name+'-'+con.currencycode}
                                        </option>
                                      ))}
                                    </select>
                                    </div>
                               */}
                  <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <label className="amt15">
                        <Trans i18nKey="Country">Country</Trans>
                      </label>
                      <br />
                      <Select
                        name="countryid"
                        placeholder={<div>Select Country</div>}
                        value={country.find(
                          (item) => item.value === this.state.countryid
                        )}
                        onChange={this.onChangeCountry}
                        options={country}
                      />
                    </div>
                  </div>
                  <p className={this.state.errorMsg}>
                    <Trans i18nKey={this.state.country_err}>
                      {this.state.country_err}
                    </Trans>
                  </p>

                  <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText"
                        id="name"
                        value={this.state.name}
                        onChange={this.onChangeName}
                        alt={this.props.coords && this.props.coords.longitude}
                        maxLength={20}
                        minLength={3}
                        placeholder=" "
                        onInput={(F) => F.target.setCustomValidity("")}
                      />
                      <span className="floating-label">
                        <Trans i18nKey="Name">Name</Trans>
                      </span>
                    </div>
                  </div>
                  {/* required onInvalid={F => F.target.setCustomValidity(t('Enter your name(It should be atleast 3 characters)'))} */}
                  {this.state.errors.name == "name" && (
                    <div className={this.state.errorMsg}>
                      <Trans i18nKey={this.state.errors.signup}>
                        {this.state.errors.signup}
                      </Trans>
                    </div>
                  )}

                  <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText"
                        type="text"
                        id="email"
                        value={this.state.email}
                        alt={this.props.coords && this.props.coords.latitude}
                        onChange={this.onChangeEmail}
                        placeholder=" "
                      />
                      <span className="floating-label">
                        <Trans i18nKey="Email">Email</Trans>
                      </span>
                    </div>
                  </div>
                  {(this.state.errors.message_info == "emailalready" ||
                    this.state.errors.email == "email") && (
                    <div className={this.state.errorMsg}>
                      <Trans i18nKey={this.state.errors.signup}>
                        {this.state.errors.signup}
                      </Trans>
                    </div>
                  )}
                  <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText"
                        id="password"
                        value={this.state.password}
                        onChange={this.onChangePassword}
                        type={this.state.password_type}
                        placeholder=" "
                      />
                      <i
                        class={this.state.password_icon}
                        onClick={this.onChangeEye}
                        aria-hidden="true"
                      ></i>
                      <span className="floating-label">
                        <Trans i18nKey="Password">Password</Trans>
                      </span>
                    </div>
                  </div>
                  {this.state.errors.password == "password" && (
                    <div className={this.state.errorMsg}>
                      <Trans i18nKey={this.state.errors.signup}>
                        {this.state.errors.signup}
                      </Trans>
                    </div>
                  )}
                  {/* <div className="edit-profile-page">
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText"
                        id="referal"
                        value={this.state.referal}
                        onChange={this.onChangeReferal}
                        alt={this.props.coords && this.props.coords.longitude}
                        maxLength={20}
                        minLength={3}
                        placeholder=" "
                      />
                      <span className="floating-label">
                        <Trans i18nKey="Referral code">Referral code</Trans>
                      </span>
                    </div>
                  </div> */}
                  {this.state.errors.message_info == "referral" && (
                    <div className="WebcameAlert">
                      <Trans i18nKey={this.state.errors.signup}>
                        {this.state.errors.signup}
                      </Trans>
                    </div>
                  )}

                  {this.state.settings.access_code == "enable" && (
                    <div className="edit-profile-page">
                      <div className="user-input-wrp amb25">
                        <br />
                        <input
                          className="inputText"
                          id="access_code"
                          value={this.state.access_code}
                          onChange={this.onChangeAccess}
                          alt={this.props.coords && this.props.coords.longitude}
                          maxLength={20}
                          minLength={3}
                          /*onKeyPress={(e) => this.restrict(e)}*/ placeholder=" "
                        />
                        <span className="floating-label">
                          <Trans i18nKey="Access code (optional)">
                            Access code (optional)
                          </Trans>
                        </span>
                      </div>
                    </div>
                  )}
                  {this.state.errors.message_info == "Access_code" && (
                    <div className="WebcameAlert">
                      <Trans i18nKey={this.state.errors.signup}>
                        {this.state.errors.signup}
                      </Trans>
                    </div>
                  )}

                  {/*<div className="edit-profile-page">
									<div className="user-input-wrp amb25">
										<br />
										<input className="inputText" id="phone1" value={this.state.phone} onClick={this.usePhoneModal} type="text" placeholder={this.state.phone} required />
										<span className="floating-label"><Trans i18nKey="Phone">Phone</Trans></span>
										<div id="customPhoneContainer" style={{ display: this.state.phoneDesignPopup === true? 'block': 'none'}}>
											<div ref={this.firebaseRef} id="firebaseui-auth-container-otp"></div>
										</div>
									</div>
								</div> */}
                  <div className="form-group amb35">
                    <label className="amt15">
                      <Trans i18nKey="Date of Birth">Date of Birth</Trans>
                    </label>

                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      onChange={this.handleDOBChange}
                      onCalendarOpen={this.handleOpenPicker}
                      value={this.state.valueDate}
                      maxDate={this.state.maxDate}
                      minDate={this.state.minDate}
                      format="y - MM - dd"
                      name="CalendarCustomValue"
                      clearIcon={this.state.disableIcon}
                      closeCalendar={this.state.closeCalendar}
                      yearPlaceholder={t("Year")}
                      monthPlaceholder={t("Month")}
                      dayPlaceholder={t("Date")}
                      InputAdornmentProps={{ position: "start" }}
                    />
                  </div>
                  <p className="WebcameAlert">
                    <Trans i18nKey={this.state.dob_err}>
                      {this.state.dob_err}
                    </Trans>
                  </p>

                  <input
                    className="inputText"
                    type="hidden"
                    id="fbid"
                    value={this.state.fbid}
                  />
                  <input
                    className="inputText"
                    type="hidden"
                    id="lat"
                    value={this.props.coords && this.props.coords.latitude}
                    alt={this.props.coords && this.props.coords.longitude}
                  />
                  <div className="form-group">
                    <label className="">
                      <span className="floating-label">
                        <Trans i18nKey="Gender">Gender</Trans>
                      </span>
                    </label>
                    <div className="row">
                      <div className="col-3">
                        <label className="radio-btn secondary_color">
                          <Trans i18nKey="Male">Male</Trans>
                          <input
                            type="radio"
                            onClick={this.setGender}
                            value="male"
                            name="radio"
                            defaultChecked
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className="col-5 col-sm-3">
                        <label className="radio-btn secondary_color">
                          <Trans i18nKey="Female">Female</Trans>
                          <input
                            type="radio"
                            onClick={this.setGender}
                            value="female"
                            name="radio"
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      {/* <div className="col-3">
											<label className="radio-btn secondary_color"><Trans i18nKey="Other">Other</Trans>    
 												<input type="radio" onClick={this.setGender}  value="other" name="radio" />
												<span className="checkmark"></span>  
											</label>
										</div> */}
                    </div>
                  </div>

                  {/* <div className="form-group" >

										<ReCAPTCHA
									    ref={recaptchaRef}
					    				sitekey={captcha_site_key}  					
					                    onChange={token => this.setState({token})}
                    			 />
									</div> */}

                  <p className="WebcameAlert">
                    <Trans i18nKey={this.state.captcha_err}>
                      {this.state.captcha_err}
                    </Trans>
                  </p>

                  <p className="WebcameAlert">
                    <b>
                      <Trans i18nKey="Note">Note</Trans>:
                    </b>{" "}
                    <Trans i18nKey="Enable web camera permission to continue the signup">
                      {" "}
                      Enable web camera permission to continue the signup
                    </Trans>
                  </p>
                  <div className={this.state.errorMsg}>
                    <Trans i18nKey={this.state.errors.signup}>
                      {this.state.errors.signup}
                    </Trans>
                  </div>
                  <div className="premium amt35 amb15">
                    <button
                      disabled={isDisable}
                      className="btn btn-bg d-flex justify-content-center width100"
                      value={this.props.coords && this.props.coords.latitude}
                      alt={this.props.coords && this.props.coords.longitude}
                      type="submit"
                    >
                      <Trans i18nKey="Signup">Signup</Trans>
                    </button>
                  </div>
                </form>
                {/* register form */}

                {/*  Webcam popup */}
                <Modal
                  isOpen={this.state.modalWebCam}
                  className="premiumPopup modal-dialog-centered vertically-center apd5"
                >
                  <ModalHeader className="headerCap">
                    <div className="webcamHead">
                      <Trans i18nKey="Take your image">Take your image</Trans>
                    </div>
                    <p className="custom_head">
                      <Trans i18nKey="Please upload your selfie image to verify your profile, this picture will not show in profile page">
                        Please upload your selfie image to verify your profile,
                        this picture will not show in profile page
                      </Trans>
                    </p>
                  </ModalHeader>
                  <ModalBody className="photoPopup">
                    <center>
                      <div className="loder-icon">
                        <div style={style} id="loader">
                          <Loader
                            type="Bars"
                            color="#ca2a1e"
                            height={30}
                            width={50}
                          />
                        </div>
                      </div>
                      <div className="blueimgCap">
                        <Webcam
                          audio={false}
                          forceScreenshotSourceSize="true"
                          ref={this.setRef}
                          mirrored
                          screenshotFormat="image/jpeg"
                          videoConstraints={videoConstraints}
                          style={{
                            display:
                              this.state.webcamPic === false ? "block" : "none",
                          }}
                        />
                        <div
                          id="capturedPhoto"
                          style={{
                            display:
                              this.state.webcamPic === true ? "block" : "none",
                          }}
                        ></div>
                        <div
                          className="webcamAlert"
                          style={{
                            display:
                              this.state.permissionAlert === true
                                ? "block"
                                : "none",
                          }}
                        >
                          <Trans i18nKey="Kindly allow your webcam Permission">
                            Kindly allow your webcam Permission
                          </Trans>
                        </div>
                      </div>
                      <div style={{ height: "180px" }}></div>
                      <div
                        className={this.state.errorMsg}
                        style={{ paddingLeft: "25px" }}
                      >
                        <Trans i18nKey={this.state.errors.captureImg}>
                          {this.state.errors.captureImg}
                        </Trans>
                      </div>
                      <div
                        className="successMsg"
                        style={{ paddingLeft: "25px" }}
                      >
                        <p>
                          {" "}
                          <Trans i18nKey="Kindly upload the image within height 1000">
                            Kindly upload the image within height 1000
                          </Trans>{" "}
                        </p>

                        <Trans i18nKey={this.state.errors.captureImg_suc}>
                          {this.state.errors.captureImg_suc}
                        </Trans>
                      </div>

                      {/* <label onClick={() => { this.toggle('2'); }} className=" custom-file-upload primary-color"> <Trans i18nKey="Back">Back</Trans></label> 
                                                <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label> */}

                      <button onClick={this.backphoto} className="Back-photo">
                        <Trans i18nKey="Back">Back</Trans>
                      </button>

                      <button
                        onClick={this.captureAgain}
                        className="retake-photo"
                        style={{
                          display:
                            this.state.hideCaptureBtn === true
                              ? "block"
                              : "none",
                        }}
                      >
                        <Trans i18nKey="Retake">Retake</Trans>
                      </button>
                      <button
                        onClick={this.capture}
                        className="cap-photo"
                        style={{
                          display:
                            this.state.hideCaptureBtn === false
                              ? "block"
                              : "none",
                        }}
                      >
                        <Trans i18nKey="Capture photo">Capture photo</Trans>
                      </button>
                      <button
                        onClick={this.saveFaceId}
                        className="cap-photo"
                        style={{
                          display:
                            this.state.hideCaptureBtn === true
                              ? "block"
                              : "none",
                        }}
                      >
                        <Trans i18nKey="Next">Next</Trans>
                      </button>
                    </center>
                  </ModalBody>
                </Modal>

                {/*<Modal isOpen={this.state.modal6} toggle={this.closeModal.bind(this, 'modal6')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal6')}><h4 class="modal-title disclaim" style={{'marginTop':"10px"}}> Your photo has been rejected</h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                            		<div className="form-group">
                           				 Cause of reason : <Trans i18nKey={this.state.message}>{this.state.message}</Trans>
                                	</div>
                                <div class="mr-3"><br/><br/><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'modal6')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal>*/}

                <Modal
                  isOpen={this.state.modal6}
                  className="premiumPopup modal-dialog-centered vertically-center apd5"
                >
                  <ModalHeader>
                    <h4 class="modal-title disclaim">
                      <Trans i18nKey="Cause of Rejection">
                        Cause of Rejection
                      </Trans>
                    </h4>
                  </ModalHeader>

                  <ModalHeader>
                    <h4 class="modal-title disclaim photo">
                      <Trans i18nKey="Your Photo has been rejected">
                        Your Photo has been rejected56
                      </Trans>
                    </h4>

                    <hr
                      class="hr"
                      style={{
                        color: "#ca2a1e",
                        backgroundColor: "#ca2a1e",
                        height: 0.3,
                        borderColor: "#ca2a1e",
                      }}
                    />
                  </ModalHeader>

                  <ModalBody>
                    <div className="premiumPop apl25 apr25 apt5 apb5">
                      <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                        <div className="premiumBenifitOverflow">
                          {/* <div className="form-group">
                 							 
                                       <div className=""><Trans i18nKey="Your photo was rejected for one of the following reasons">Your photo was rejected for one of the following reasons:</Trans></div>                  							
                							</div>               							 */}

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Poor quality photo (clarity, brightness).">
                                Poor quality photo (clarity, brightness).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Indecent photo (e.g. shirtless, too low neckline).">
                                Indecent photo (e.g. shirtless, too low
                                neckline).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Invalid photo (shadow, blurry, reflection).">
                                Invalid photo (shadow, blurry, reflection).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Unidentifiable photo (filter).">
                                Unidentifiable photo (filter).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Indecent photo (nudity).">
                                Indecent photo (nudity).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Invalid photo (format not compliant).">
                                Invalid photo (format not compliant).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="Good quality photos are essential, choose them carefully.">
                                Good quality photos are essential, choose them
                                carefully.
                              </Trans>
                            </div>
                          </div>
                        </div>
                      </div>

                      <center>
                        <button
                          onClick={this.closeModal.bind(this, "modal6")}
                          className="capphoto"
                        >
                          <Trans i18nKey="Ok">Ok</Trans>
                        </button>{" "}
                      </center>
                    </div>
                  </ModalBody>
                </Modal>

                <Modal
                  isOpen={this.state.face_recognition_check_model}
                  className="premiumPopup modal-dialog-centered vertically-center apd5"
                >
                  <ModalHeader>
                    <h4 class="modal-title disclaim">
                      <Trans i18nKey="Cause of Rejection">
                        Cause of Rejection
                      </Trans>
                    </h4>
                  </ModalHeader>

                  <ModalHeader>
                    <h4 class="modal-title disclaim photo">
                      <Trans i18nKey="Your Photo has been rejected">
                        Your Photo has been rejected
                      </Trans>
                    </h4>

                    <hr
                      class="hr"
                      style={{
                        color: "#ca2a1e",
                        backgroundColor: "#ca2a1e",
                        height: 0.3,
                        borderColor: "#ca2a1e",
                      }}
                    />
                  </ModalHeader>

                  <ModalBody>
                    <div className="premiumPop apl25 apr25 apt5 apb5">
                      <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                        <div className="premiumBenifitOverflow">
                          {/* <div className="form-group">
                 							 
                                       <div className=""><Trans i18nKey="Your photo was rejected for one of the following reasons">Your photo was rejected for one of the following reasons:</Trans></div>                  							
                							</div>               							 */}

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="The photo is not compliant (your face was not detected).">
                                The photo is not compliant (your face was not
                                detected).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="The photo is of poor quality (lack of brightness, you were not identified).">
                                The photo is of poor quality (lack of
                                brightness, you were not identified).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="The photo is invalid (shadow, blurry, reflection).">
                                The photo is invalid (shadow, blurry,
                                reflection).
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="The photo is unidentifiable (unrecommended filter).">
                                The photo is unidentifiable (unrecommended
                                filter).
                              </Trans>
                            </div>
                          </div>

                          {this.state.langKey == "ar" ? (
                            <div className="form-group">
                              <div class="tickIco mr-2"></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <Trans i18nKey="The photo is indecent (nudity).">
                                  The photo is indecent (nudity).
                                </Trans>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          {this.state.langKey == "ar" ? (
                            <div className="form-group">
                              <div class="tickIco mr-2"></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <Trans i18nKey="The photo is invalid (the format does not conform to standards).">
                                  The photo is invalid (the format does not
                                  conform to standards).
                                </Trans>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="To obtain your badge; the photo must be compliant and recent (less than 6 months)">
                                To obtain your badge; the photo must be
                                compliant and recent (less than 6 months)
                              </Trans>
                            </div>
                          </div>
                        </div>
                      </div>

                      <center>
                        <button
                          onClick={this.closeModal.bind(
                            this,
                            "face_recognition_check_model"
                          )}
                          className="capphoto"
                        >
                          <Trans i18nKey="Ok">Ok</Trans>
                        </button>{" "}
                      </center>
                    </div>
                  </ModalBody>
                </Modal>

                {/* Mobile OTP Popup */}
                <Modal
                  isOpen={this.state.modalOTP}
                  toggle={this.closeModal.bind(this, "modalOTP")}
                  className="premiumPopup modal-dialog-centered vertically-center apd5"
                >
                  <ModalHeader toggle={this.closeModal.bind(this, "modalOTP")}>
                    <h4 class="modal-title">
                      <Trans i18nKey="MobileOTP">
                        Mobile number verification
                      </Trans>
                    </h4>
                  </ModalHeader>
                  <input
                    className="inputText"
                    type="hidden"
                    id="phonehiddenval"
                    onClick={this.closeModal.bind(this, "modalOTP")}
                  />
                  <ModalBody>
                    <div
                      ref={this.firebaseRef}
                      id="firebaseui-auth-container-otp"
                    ></div>
                  </ModalBody>
                </Modal>

                <Modal
                  isOpen={this.state.modalInfo}
                  className="premiumPopup modal-dialog-centered vertically-center apd5"
                >
                  <ModalHeader>
                    <h4 class="modal-title disclaim">
                      <Trans i18nKey="Disclaimer Information">
                        Disclaimer Information
                      </Trans>
                    </h4>
                  </ModalHeader>
                  <ModalBody>
                    <div className="premiumPop apl25 apr25 apt5 apb5">
                      <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                        <div className="premiumBenifitOverflow">
                          {/* <div className="form-group">
                 							 
											  <div className=""><Trans i18nKey="The photo must be in standard format and compliant:">The photo must be in standard format and compliant:</Trans></div>                  							
												   </div> */}

                          {this.state.langKey == "ar" ? (
                            <div className="form-group">
                              <div class="tickIco mr-2"></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <Trans i18nKey="The image must be standard and compatible">
                                  Good quality photos are essential, choose them
                                  carefully.
                                </Trans>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="We do not allow guns, blood, nudity and unnecessary images">
                                We do not allow guns, blood, nudity and
                                unnecessary images
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="We do not allow any objects images for verification">
                                We do not allow any objects images for
                                verification
                              </Trans>
                            </div>
                          </div>

                          <div className="form-group">
                            <div class="tickIco mr-2"></div>
                            <div
                              className={
                                this.state.langKey == "ar" ? "amll36" : "amll35"
                              }
                            >
                              <Trans i18nKey="If the uploaded image is not clear then the image will not be accepted. So you need to re-upload the correct image">
                                If the uploaded image is not clear then the
                                image will not be accepted. So you need to
                                re-upload the correct image.
                              </Trans>
                            </div>
                          </div>
                          {this.state.langKey == "ar" ? (
                            <div className="form-group">
                              <div class="tickIco mr-2"></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <Trans i18nKey="After face verification you need to upload a profile picture. If this image is not similar to your selfie, it will not be accepted, so you will need to upload another image">
                                  After face verification you need to upload a
                                  profile picture. If this image is not similar
                                  to your selfie, it will not be accepted, so
                                  you will need to upload another image.
                                </Trans>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.langKey != "fr" &&
                          this.state.langKey != "en" ? (
                            <div className="form-group">
                              <div class="tickIco mr-2"></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <Trans i18nKey="On profile upload screen popup We do not allow guns, blood, nudity and unnecessary images">
                                  {" "}
                                  On profile upload screen popup We do not allow
                                  guns, blood, nudity and unnecessary images
                                </Trans>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.langKey != "fr" &&
                          this.state.langKey != "en" ? (
                            <div className="form-group">
                              <div class="tickIco mr-2"></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <Trans i18nKey="If above mentioned verification is not satisfactory then we will show proper alert">
                                  If above mentioned verification is not
                                  satisfactory then we will show proper alert
                                </Trans>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.langKey != "ar" ? (
                            <div className="form-group">
                              <div
                                class="mr-2"
                                style={{ height: "25px" }}
                              ></div>
                              <div
                                className={
                                  this.state.langKey == "ar"
                                    ? "amll36"
                                    : "amll35"
                                }
                              >
                                <b>
                                  <Trans i18nKey="A profile with an authenticated badge = a verified profile = more matches ;) = 1 marriage!">
                                    A profile with an authenticated badge = a
                                    verified profile = more matches ;) = 1
                                    marriage!
                                  </Trans>{" "}
                                </b>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <button onClick={this.chooses} className="cap-photo">
                        <Trans i18nKey="Continue">Continue</Trans>
                      </button>
                      <button
                        onClick={this.closeModal.bind(this, "modalInfo")}
                        className="cap-photo"
                      >
                        <Trans i18nKey="Back">Back</Trans>
                      </button>
                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </div>
          </div>

          <div class="footerSty">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-7 col-lg-7 col-xl-8  text-center text-sm-left">
                  <span class="sma-16"></span>
                </div>
                <div class="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4">
                  <div class="text-center text-sm-right mt-2 mt-sm-0">
                    <div>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={this.state.ios_url}
                      >
                        <div class="inline-block aml15 amr15">
                          <span class="apr5 apl5 align-middle">
                            <i
                              class="fa fa-apple apk-20 "
                              aria-hidden="true"
                            ></i>
                          </span>
                          <Trans i18nKey="AppStore">
                            <span className="floating-label">App Store</span>{" "}
                          </Trans>
                        </div>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={this.state.android_url}
                      >
                        <div class="inline-block">
                          <span class="apr5 apl5 align-middle">
                            <i
                              class="fa fa-android apk-20"
                              aria-hidden="true"
                            ></i>
                          </span>
                          <Trans i18nKey="GooglePlay">
                            <span className="floating-label">Google Play</span>{" "}
                          </Trans>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Forgot Password Popup */}
          <Modal
            isOpen={this.state.modal2}
            className="premiumPopup modal-dialog-centered appofDay signinPagePop  apd5 par"
          >
            <ModalHeader className="apk-24 d-none"></ModalHeader>

            <div>
              {this.state.face_rec === true ? (
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <ModalHeader>
                      <h4 class="modal-title">
                        <Trans i18nKey="Iamhereto">I am here to</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody>
                      <div className="premiumPop apl25 apr25 apt5 apb5">
                        <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                          {this.state.items.map((item, index) => (
                            <div className="">
                              <div className="text-center" key={index}>
                                <div className="iconimg apd15 apl20 apr20">
                                  <img
                                    onError={this.addDefaultSrc}
                                    src={item.icon}
                                    alt={item.id}
                                    className={
                                      this.state.activehere === index
                                        ? "navigation--active"
                                        : ""
                                    }
                                    onClick={this.handlehereClick.bind(
                                      this,
                                      index
                                    )}
                                    value={item.id}
                                  />
                                  <h6 className="amb0 amt5" value={item.id}>
                                    <Trans i18nKey={item.name}>
                                      {item.name}
                                    </Trans>{" "}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div
                          className={this.state.errorMsg}
                          style={{ paddingLeft: "25px" }}
                        >
                          <Trans i18nKey={this.state.errors.here_to}>
                            {this.state.errors.here_to}
                          </Trans>
                        </div>
                        <div
                          className="sidebarLastContent text-center"
                          data-toggle="modal"
                          data-target="#next-page"
                        >
                          <button
                            className="btn-common btn-block"
                            onClick={this.choose}
                          >
                            <Trans i18nKey="Next">Next</Trans>
                          </button>
                        </div>
                      </div>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="2">
                    {/*								<ModalHeader ><h4 class="modal-title"><Trans i18nKey="choose">Choose</Trans></h4></ModalHeader>
                     */}{" "}
                    <ModalBody className="selfie_popup_modalbody">
                      {/*<div className="signStepSecondWrapper relPos">
									
									
									<div className="d-flex justify-content-between apd25 apb15">
										<div className="text-center">
											<button className="btn-common btn-block" onClick={this.validate}><Trans i18nKey="Selfie">Selfie</Trans></button>
										</div>
										<div className="text-center">
											<button className="btn-common btn-block" onClick={() => { this.toggle('3'); }}><Trans i18nKey="Gallery">Gallery</Trans></button>
										</div>
									</div>
									
								</div>*/}
                      <div
                        class="premiumPop"
                        style={{ width: "70%", margin: "0 auto" }}
                      >
                        <img src={face} alt="" class="img-fluid" />
                      </div>
                      <div class="sidebarLastContent selfie_popup_custom_style text-center">
                        <button
                          className="btn-common btn-block"
                          onClick={this.validate}
                        >
                          <Trans i18nKey="Take Selfie by Camera">
                            Take Selfie by Camera
                          </Trans>
                        </button>
                      </div>
                      <div class="sidebarLastContent selfie_popup_custom_style text-center">
                        <button
                          className="btn-common btn-block"
                          onClick={() => {
                            this.toggle("3");
                          }}
                        >
                          <Trans i18nKey="Upload the profile image by Gallery">
                            Upload the profile image by Gallery
                          </Trans>
                        </button>
                      </div>
                    </ModalBody>
                  </TabPane>
                  <TabPane tabId="3">
                    <ModalBody>
                      <div className="signStepSecondWrapper relPos">
                        <div className="centerImgSelecting photo-rotation">
                          <label className=" custom-file-upload">
                            <form onSubmit={this.onFormSubmit}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                onChange={this.onChange}
                                style={{ opacity: "0" }}
                              />
                              <img id="image1" src={this.state.file} alt="" />
                            </form>
                          </label>
                          <div className="loder-icon">
                            <div style={style1} id="loader_profile">
                              <Loader
                                type="Bars"
                                color="#ca2a1e"
                                height={30}
                                width={50}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="blueBannerSignIn">
                          {" "}
                          <div className="text-center apk-30 text-light pt-2">
                            <Trans i18nKey="Upload great photos">
                              Upload great photos
                            </Trans>
                          </div>
                        </div>
                        <div style={{ height: "180px" }}></div>
                        <div
                          className={this.state.errorMsg}
                          style={{ paddingLeft: "25px" }}
                        >
                          <Trans i18nKey={this.state.errors.uploadimage}>
                            {this.state.errors.uploadimage}
                          </Trans>
                        </div>
                        <div
                          className="successMsg"
                          style={{ paddingLeft: "25px" }}
                        >
                          <p>
                            {" "}
                            <Trans i18nKey="Kindly upload the image within height 1000">
                              Kindly upload the image within height 1000
                            </Trans>{" "}
                          </p>
                          <Trans i18nKey={this.state.errors.uploadimage_suc}>
                            {this.state.errors.uploadimage_suc}
                          </Trans>
                        </div>
                        <div className="d-flex justify-content-between apd25 apb15">
                          <span
                            id="next"
                            style={{ display: "none" }}
                            className="apk-18 bold-font pointCurs"
                            onClick={() => {
                              this.toggle("3");
                            }}
                          >
                            <Trans i18nKey="Next">Next</Trans>
                          </span>
                          {this.state.fileUploaded === "none" ? (
                            <form
                              style={{ width: "100%" }}
                              onSubmit={this.onFormSubmit}
                            >
                              <span className="apk-18 bold-font pink-color">
                                {/* back button hide */}
                                <label
                                  onClick={() => {
                                    this.toggle("2");
                                  }}
                                  style={{
                                    display:
                                      this.state.backbutton === true
                                        ? "block"
                                        : "none",
                                  }}
                                  className=" custom-file-upload primary-color"
                                >
                                  {" "}
                                  <Trans i18nKey="Back">Back</Trans>
                                </label>

                                <label className=" custom-file-upload primary-color">
                                  {" "}
                                  <Trans i18nKey="Add Photos">Add Photos</Trans>
                                  <input
                                    id="file-upload"
                                    type="file"
                                    accept=".jpg,.jpeg,.png"
                                    onChange={this.onChange}
                                  />
                                </label>
                              </span>
                            </form>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="4">
                    <ModalHeader>
                      <h4 class="modal-title">
                        <Trans i18nKey="interest">Interest</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody>
                      <form onSubmit={this.onSubmitinterest}>
                        <div
                          className="modal-content border-radius border-none"
                          style={{ padding: "1rem" }}
                        >
                          <div className="modal-body profile-page ">
                            <div className="input-group border-bottom apb10">
                              <span className="input-group-append">
                                <button
                                  className="btn search-btn border-none"
                                  type="button"
                                >
                                  <img
                                    src={require("../../assets/img/search.png")}
                                    alt="logo"
                                    className=""
                                  />
                                </button>
                              </span>
                              <input
                                className="form-control py-2  border-none"
                                type="search"
                                value={value}
                                onChange={this.handleChange}
                                placeholder={t("Search your Interest")}
                              />
                            </div>

                            <div className="interst-list appodDayoverflow">
                              <FilterResults
                                value={value}
                                data={data}
                                renderResults={(results) => (
                                  <div>
                                    {results.map((el, i) => {
                                      if (mine !== null) {
                                        if (mine.indexOf(el.name) > -1) {
                                          return (
                                            <label
                                              key={el.name}
                                              className="interst-option amb0 apt10 apb10 border-bottom"
                                            >
                                              <span>{el.name}</span>
                                              <input
                                                type="checkbox"
                                                onChange={this.onToggle.bind(
                                                  this,
                                                  i
                                                )}
                                                name="interestcheck"
                                                value={el.original_name}
                                                defaultChecked={
                                                  mine.indexOf(
                                                    el.original_name
                                                  ) > -1
                                                    ? "true"
                                                    : ""
                                                }
                                              />
                                              <span className="checkmark"></span>
                                            </label>
                                          );
                                        } else {
                                          return (
                                            <label
                                              key={el.name}
                                              className="interst-option amb0 apt10 apb10 border-bottom"
                                            >
                                              <span>{el.name}</span>
                                              <input
                                                type="checkbox"
                                                onChange={this.onToggle.bind(
                                                  this,
                                                  i
                                                )}
                                                name="interestcheck"
                                                value={el.original_name}
                                              />
                                              <span className="checkmark"></span>
                                            </label>
                                          );
                                        }
                                      } else {
                                        return (
                                          <label
                                            key={el.name}
                                            className="interst-option amb0 apt10 apb10 border-bottom"
                                          >
                                            <span>{el.name}</span>
                                            <input
                                              type="checkbox"
                                              onChange={this.onToggle.bind(
                                                this,
                                                i
                                              )}
                                              name="interestcheck"
                                              value={el.original_name}
                                            />
                                            <span className="checkmark"></span>
                                          </label>
                                        );
                                      }
                                    })}
                                  </div>
                                )}
                              />
                              <br />
                            </div>
                          </div>
                          <div
                            className="errorMsg"
                            style={{ paddingLeft: "25px" }}
                          >
                            <Trans i18nKey={this.state.nointerest}>
                              {this.state.nointerest}
                            </Trans>
                          </div>

                          <div className=" interest-save border-top-none text-right">
                            <div class="premium amt30 amb10">
                              <button
                                class="btn btn-bg d-flex justify-content-center width100"
                                type="submit"
                              >
                                {" "}
                                <Trans i18nKey="Save">Save</Trans>{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="5">
                    <ModalHeader>
                      <h4 class="modal-title">
                        <Trans i18nKey="location">location</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody className="apd5Imp">
                      <div className="modal-body edit-profile-page">
                        <form
                          className=""
                          onSubmit={this.onSubmitlocationsearch}
                        >
                          <div className="user-input-wrp amb35">
                            <br />
                            {/* <GoogleComponent
                                        apiKey={API_KEY}
                                        language={'en'}
                                        //country={'country:in|country:us'}
                                        coordinates={true}
                                        locationBoxStyle={'inputText'}
										locationListStyle={'custom-style-list'}
										// changes on location
										onChange={(e) => { this.setState({ place: e.place, lat_search: e.coordinates.lat , lon_search: e.coordinates.lng }) }}  />*/}
                            <Autocomplete
                              apiKey={API_KEY}
                              onPlaceSelected={(place) => {
                                this.setState({
                                  place: place.formatted_address,
                                  lat_search: place.geometry.location.lat(),
                                  lon_search: place.geometry.location.lng(),
                                });
                              }}
                              types={["(regions)"]}
                              placeholder={t("Indicate a location")}
                              //componentRestrictions={{country: "ru"}}
                            />
                          </div>
                          <div className={this.state.errorMsg}>
                            <Trans i18nKey={this.state.errors.locationsearch}>
                              {this.state.errors.locationsearch}
                            </Trans>
                          </div>
                          <div className="premium">
                            <button
                              type="Submit"
                              className="btn btn-bg width100 justify-content-center amg0"
                            >
                              {" "}
                              <Trans i18nKey="Joinwith">
                                Join with Moulook
                              </Trans>{" "}
                            </button>
                          </div>
                        </form>
                      </div>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="6">
                    <ModalHeader>
                      <h4 class="otp-modal-title">
                        <Trans i18nKey="Verification">Verification</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody className="apd5Imp">
                      <div className="modal-body edit-profile-page">
                        <form className="" onSubmit={this.handleSubmit}>
                          <div className="user-input-wrp amb20 otpHolder">
                            <p class="otp-sub-title text-center">
                              <Trans i18nKey="OTPCODE">
                                Get OTP code from registered mail
                              </Trans>
                            </p>
                            <div className="otp-cnt">
                              <OtpInput
                                inputStyle="inputStyle"
                                numInputs={numInputs}
                                isDisabled={isDisabled}
                                hasErrored={hasErrored}
                                errorStyle="error"
                                onChange={this.handleOtpChange}
                                separator={<span>{separator}</span>}
                                isInputNum={isInputNum}
                                shouldAutoFocus
                                value={otp}
                              />
                            </div>
                            <div className={this.state.errorMsg}>
                              <Trans i18nKey={this.state.errors.otpverify}>
                                {this.state.errors.otpverify}
                              </Trans>
                            </div>
                            <div className="btn-row text-center">
                              <button
                                className="btn margin-top--large clrBtn"
                                type="button"
                                disabled={isDisabled}
                                onClick={this.clearOtp}
                              >
                                <Trans i18nKey="Clear">Clear</Trans>
                              </button>

                              <button
                                className="btn margin-top--large vryBtn"
                                disabled={otp.length < numInputs}
                              >
                                <Trans i18nKey="Verify">Verify</Trans>
                              </button>
                            </div>

                            <div className="btn-row text-center">
                              <button
                                className="btn margin-top--large vryBtn"
                                onClick={this.handleResendOtp}
                              >
                                <Trans i18nKey="Resend">Resend</Trans>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </ModalBody>
                  </TabPane>
                </TabContent>
              ) : (
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <ModalHeader>
                      <h4 class="modal-title">
                        <Trans i18nKey="Iamhereto">I am here to</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody>
                      <div className="premiumPop apl25 apr25 apt5 apb5">
                        <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                          {this.state.items.map((item, index) => (
                            <div className="">
                              <div className="text-center" key={index}>
                                <div className="iconimg apd15 apl20 apr20">
                                  <img
                                    onError={this.addDefaultSrc}
                                    src={item.icon}
                                    alt={item.id}
                                    className={
                                      this.state.activehere === index
                                        ? "navigation--active"
                                        : ""
                                    }
                                    onClick={this.handlehereClick.bind(
                                      this,
                                      index
                                    )}
                                    value={item.id}
                                  />
                                  <h6 className="amb0 amt5" value={item.id}>
                                    <Trans i18nKey={item.name}>
                                      {item.name}
                                    </Trans>{" "}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div
                          className={this.state.errorMsg}
                          style={{ paddingLeft: "25px" }}
                        >
                          <Trans i18nKey={this.state.errors.here_to}>
                            {this.state.errors.here_to}
                          </Trans>
                        </div>
                        <div
                          className="sidebarLastContent text-center"
                          data-toggle="modal"
                          data-target="#next-page"
                        >
                          <button
                            className="btn-common btn-block"
                            onClick={this.choose}
                          >
                            <Trans i18nKey="Next">Next</Trans>
                          </button>
                        </div>
                      </div>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="2">
                    <ModalBody>
                      <div className="signStepSecondWrapper relPos">
                        <div className="centerImgSelecting photo-rotation">
                          <label className=" custom-file-upload">
                            <form onSubmit={this.onFormSubmit}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                onChange={this.onChange}
                                style={{ opacity: "0" }}
                              />
                              <img id="image1" src={this.state.file} alt="" />
                            </form>
                          </label>
                          <div className="loder-icon">
                            <div style={style1} id="loader_profile">
                              <Loader
                                type="Bars"
                                color="#ca2a1e"
                                height={30}
                                width={50}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="blueBannerSignIn">
                          {" "}
                          <div className="text-center apk-30 text-light pt-2">
                            <Trans i18nKey="Upload great photos">
                              Upload great photos
                            </Trans>
                          </div>
                        </div>
                        <div style={{ height: "180px" }}></div>
                        <div
                          className={this.state.errorMsg}
                          style={{ paddingLeft: "25px" }}
                        >
                          <Trans i18nKey={this.state.errors.uploadimage}>
                            {this.state.errors.uploadimage}
                          </Trans>
                        </div>
                        <div
                          className="successMsg"
                          style={{ paddingLeft: "25px" }}
                        >
                          <p>
                            {" "}
                            <Trans i18nKey="Kindly upload the image within height 1000">
                              Kindly upload the image within height 1000
                            </Trans>{" "}
                          </p>
                          <Trans i18nKey={this.state.errors.uploadimage_suc}>
                            {this.state.errors.uploadimage_suc}
                          </Trans>
                        </div>
                        <div className="d-flex justify-content-between apd25 apb15">
                          <span
                            id="next"
                            style={{ display: "none" }}
                            className="apk-18 bold-font pointCurs"
                            onClick={() => {
                              this.toggle("3");
                            }}
                          >
                            <Trans i18nKey="Next">Next</Trans>
                          </span>
                          {this.state.fileUploaded === "none" ? (
                            <form onSubmit={this.onFormSubmit}>
                              <span className="apk-18 bold-font pink-color">
                                <label className=" custom-file-upload primary-color">
                                  {" "}
                                  <Trans i18nKey="Add Photos">Add Photos</Trans>
                                  <input
                                    id="file-upload"
                                    type="file"
                                    accept=".jpg,.jpeg,.png"
                                    onChange={this.onChange}
                                  />
                                </label>
                              </span>
                            </form>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="4">
                    <ModalHeader>
                      <h4 class="modal-title">
                        <Trans i18nKey="interest">Interest</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody>
                      <form onSubmit={this.onSubmitinterest}>
                        <div
                          className="modal-content border-radius border-none"
                          style={{ padding: "1rem" }}
                        >
                          <div className="modal-body profile-page ">
                            <div className="input-group border-bottom apb10">
                              <span className="input-group-append">
                                <button
                                  className="btn search-btn border-none"
                                  type="button"
                                >
                                  <img
                                    src={require("../../assets/img/search.png")}
                                    alt="logo"
                                    className=""
                                  />
                                </button>
                              </span>
                              <input
                                className="form-control py-2  border-none"
                                type="search"
                                value={value}
                                onChange={this.handleChange}
                                placeholder={t("Search your Interest")}
                              />
                            </div>

                            <div className="interst-list appodDayoverflow">
                              <FilterResults
                                value={value}
                                data={data}
                                renderResults={(results) => (
                                  <div>
                                    {results.map((el, i) => {
                                      if (mine !== null) {
                                        if (mine.indexOf(el.name) > -1) {
                                          return (
                                            <label
                                              key={el.name}
                                              className="interst-option amb0 apt10 apb10 border-bottom"
                                            >
                                              <span>{el.name}</span>
                                              <input
                                                type="checkbox"
                                                onChange={this.onToggle.bind(
                                                  this,
                                                  i
                                                )}
                                                name="interestcheck"
                                                value={el.original_name}
                                                defaultChecked={
                                                  mine.indexOf(
                                                    el.original_name
                                                  ) > -1
                                                    ? "true"
                                                    : ""
                                                }
                                              />
                                              <span className="checkmark"></span>
                                            </label>
                                          );
                                        } else {
                                          return (
                                            <label
                                              key={el.name}
                                              className="interst-option amb0 apt10 apb10 border-bottom"
                                            >
                                              <span>{el.name}</span>
                                              <input
                                                type="checkbox"
                                                onChange={this.onToggle.bind(
                                                  this,
                                                  i
                                                )}
                                                name="interestcheck"
                                                value={el.original_name}
                                              />
                                              <span className="checkmark"></span>
                                            </label>
                                          );
                                        }
                                      } else {
                                        return (
                                          <label
                                            key={el.name}
                                            className="interst-option amb0 apt10 apb10 border-bottom"
                                          >
                                            <span>{el.name}</span>
                                            <input
                                              type="checkbox"
                                              onChange={this.onToggle.bind(
                                                this,
                                                i
                                              )}
                                              name="interestcheck"
                                              value={el.original_name}
                                            />
                                            <span className="checkmark"></span>
                                          </label>
                                        );
                                      }
                                    })}
                                  </div>
                                )}
                              />
                              <br />
                            </div>
                          </div>
                          <div
                            className="errorMsg"
                            style={{ paddingLeft: "25px" }}
                          >
                            <Trans i18nKey={this.state.nointerest}>
                              {this.state.nointerest}
                            </Trans>
                          </div>

                          <div className=" interest-save border-top-none text-right">
                            <div class="premium amt30 amb10">
                              <button
                                class="btn btn-bg d-flex justify-content-center width100"
                                type="submit"
                              >
                                {" "}
                                <Trans i18nKey="Save">Save</Trans>{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="5">
                    <ModalHeader>
                      <h4 class="modal-title">
                        <Trans i18nKey="location">location</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody className="apd5Imp">
                      <div className="modal-body edit-profile-page">
                        <form
                          className=""
                          onSubmit={this.onSubmitlocationsearch}
                        >
                          <div className="user-input-wrp amb35">
                            <br />
                            {/* <GoogleComponent
                                        apiKey={API_KEY}
                                        language={'en'}
                                        //country={'country:in|country:us'}
                                        coordinates={true}
                                        locationBoxStyle={'inputText'}
										locationListStyle={'custom-style-list'}
										// changes on location
										onChange={(e) => { this.setState({ place: e.place, lat_search: e.coordinates.lat , lon_search: e.coordinates.lng }) }}  />*/}
                            <Autocomplete
                              apiKey={API_KEY}
                              onPlaceSelected={(place) => {
                                this.setState({
                                  place: place.formatted_address,
                                  lat_search: place.geometry.location.lat(),
                                  lon_search: place.geometry.location.lng(),
                                });
                              }}
                              types={["(regions)"]}
                              placeholder={t("Indicate a location")}
                              //componentRestrictions={{country: "ru"}}
                            />
                          </div>
                          <div className={this.state.errorMsg}>
                            <Trans i18nKey={this.state.errors.locationsearch}>
                              {this.state.errors.locationsearch}
                            </Trans>
                          </div>
                          <div className="premium">
                            <button
                              type="Submit"
                              className="btn btn-bg width100 justify-content-center amg0"
                            >
                              {" "}
                              <Trans i18nKey="Joinwith">
                                Join with Moulook
                              </Trans>{" "}
                            </button>
                          </div>
                        </form>
                      </div>
                    </ModalBody>
                  </TabPane>

                  <TabPane tabId="6">
                    <ModalHeader>
                      <h4 class="otp-modal-title">
                        <Trans i18nKey="Verification">Verification</Trans>
                      </h4>
                    </ModalHeader>
                    <ModalBody className="apd5Imp">
                      <div className="modal-body edit-profile-page">
                        <form className="" onSubmit={this.handleSubmit}>
                          <div className="user-input-wrp amb20 otpHolder">
                            <p class="otp-sub-title text-center">
                              <Trans i18nKey="OTPCODE">
                                Get OTP code from registered mail
                              </Trans>
                            </p>
                            <div className="otp-cnt">
                              <OtpInput
                                inputStyle="inputStyle"
                                numInputs={numInputs}
                                isDisabled={isDisabled}
                                hasErrored={hasErrored}
                                errorStyle="error"
                                onChange={this.handleOtpChange}
                                separator={<span>{separator}</span>}
                                isInputNum={isInputNum}
                                shouldAutoFocus
                                value={otp}
                              />
                            </div>
                            <div className={this.state.errorMsg}>
                              <Trans i18nKey={this.state.errors.otpverify}>
                                {this.state.errors.otpverify}
                              </Trans>
                            </div>
                            <div className="btn-row text-center">
                              <button
                                className="btn margin-top--large clrBtn"
                                type="button"
                                disabled={isDisabled}
                                onClick={this.clearOtp}
                              >
                                <Trans i18nKey="Clear">Clear</Trans>
                              </button>

                              <button
                                className="btn margin-top--large vryBtn"
                                disabled={otp.length < numInputs}
                              >
                                <Trans i18nKey="Verify">Verify</Trans>
                              </button>
                            </div>

                            <div className="btn-row text-center">
                              <button
                                className="btn margin-top--large vryBtn"
                                onClick={this.handleResendOtp}
                              >
                                <Trans i18nKey="Resend">Resend</Trans>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </ModalBody>
                  </TabPane>
                </TabContent>
              )}
            </div>
          </Modal>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

export default withTranslation("translations")(withRouter(Signin));
